/* AMC — restaurare poziție scroll la „înapoi" (toate device-urile).
   Când revii pe o pagină prin back/forward, te pune fix unde erai
   (ex. la produsul din pagina de categorie pe care l-ai deschis). */
(function(){
  try{ if(!('sessionStorage' in window)) return; }catch(e){ return; }
  if('scrollRestoration' in history){ try{ history.scrollRestoration='manual'; }catch(e){} }
  function key(){ return 'amc:sy:'+location.pathname+location.search; }
  function save(){ try{ sessionStorage.setItem(key(), String(window.scrollY||window.pageYOffset||0)); }catch(e){} }
  var t;
  window.addEventListener('scroll', function(){ clearTimeout(t); t=setTimeout(save,100); }, {passive:true});
  window.addEventListener('pagehide', save);
  window.addEventListener('beforeunload', save);
  function isBackForward(){
    try{
      var nav=performance.getEntriesByType('navigation')[0];
      if(nav && nav.type==='back_forward') return true;
      if(performance.navigation && performance.navigation.type===2) return true; /* legacy */
    }catch(e){}
    return false;
  }
  function restore(){
    try{
      var y=sessionStorage.getItem(key());
      if(y===null) return;
      window.scrollTo(0, parseInt(y,10)||0);
    }catch(e){}
  }
  /* bfcache (Safari / majoritatea mobilelor) + revenire normală după back/forward */
  window.addEventListener('pageshow', function(e){
    if(e.persisted || isBackForward()){ restore(); setTimeout(restore,50); }
  });
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', function(){ if(isBackForward()) restore(); });
  } else if(isBackForward()){ restore(); }
})();
